<template>
  <v-row :dense="dense">
    <v-col cols="12">
      <BTextField
        v-model="form.search"
        :label="label"
        :loading="isLoading"
        :skeleton="skeleton"
        :placeholder="placeholder"
        @input="onChangeDebounced"
        @keydown="onKeyDown"
      />
    </v-col>
  </v-row>
</template>

<script>
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'
import { DEBOUNCE_TIMEOUT } from '@/helpers/enums/params'

import BTextField from '@/components/forms/BTextField.vue'


export const createDefaultData = () => ({
  search: void 0,
})

export default {
  name: 'BListFilter',
  inject: ['$validator'],
  components: {
    BTextField,
  },
  inheritAttrs: false,
  model: {
    prop: 'data',
  },
  props: {
    skeleton: Boolean,
    label: {
      type: String,
      // required: true,
    },
    placeholder: {
      type: String,
      default: 'Начните вводить...',
    },
    data: {
      type: Object,
      default: createDefaultData,
    },
    dense: Boolean,
  },
  data: () => ({
    isLoading: false,
    isInputChanged: false,
    isCreated: false,
    form: createDefaultData(),
  }),
  watch: {
    data(value) {
      const data = value || createDefaultData()
      if (!this.isInputChanged) {
        if (this.isCreated) {
          this.form = {
            ...createDefaultData(),
          }
          this.onChangeDebounced.cancel()
          this.onChangeDebounced()
        } else {
          this.form = {
            ...createDefaultData(),
            ...JSON.parse(JSON.stringify(data)),
          }
        }
      }
      this.isInputChanged = false
      this.isCreated = false
    },
  },
  created() {
    this.isCreated = true
    this.onChangeDebounced = debounce(
      this.onChange,
      DEBOUNCE_TIMEOUT,
    )
  },
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
    async onChange() {
      const result = await this.$validator.validate()
      if (!result) return
      if (!this.isInputChanged && isEqual(this.data, this.form)) return

      this.$emit('input', this.form)
      this.$emit('change', this.form, this.toggleLoading)
    },
    onKeyDown() {
      this.isInputChanged = true
      this.onChangeDebounced.cancel()
      this.onChangeDebounced()
    },
  },
}
</script>
